import { AddVisitInfo, DocumentTypeInfo, GenderInfo, ShipInfo, ShipPlacesInfo, VisitInfo } from "../types/visitTypes";
import { axiosInstance } from "../utils/axiosInstance";
import RescoStorage from "../utils/rescoStorage";

const VisitAPI = {
  GetShipsList: () => {        
    return axiosInstance.get<ShipInfo[]>(
      `Visit/GetShipsList`
    );
  },
  GetShipsPlacesList: (shipId: number) => {    
    const params = new URLSearchParams({
      facilityId: shipId?.toString(),
    });

    return axiosInstance.get<ShipPlacesInfo[]>(
      `Visit/GetShipsPlacesList`, {params}
    );
  },
  GetDocumentTypeList: () => {        
    return axiosInstance.get<DocumentTypeInfo[]>(
      `Visit/GetDocumentTypeList`
    );
  },
  GetGenderList: () => {        
    return axiosInstance.get<GenderInfo[]>(
      `Visit/GetGenderList`
    );
  },
  GetNationalityList: () => {        
    return axiosInstance.get(
      `Lookup/GetNationalityList`
    );
  },
  GetVisitList: (folioId: number) => {    
    return axiosInstance.get<VisitInfo[]>(
      `Visit/GetVisitList`, {        
        headers: { Authorization: `Bearer ${RescoStorage.getToken()}` },
        params: { folioId: folioId?.toString()}
      }
    );
  },
  VisitExists: (visit: AddVisitInfo|undefined) => {    
    return axiosInstance.post<any>(
      `Visit/VisitExists`, visit,{        
        headers: { Authorization: `Bearer ${RescoStorage.getToken()}` } 
      }
    );
  },
  AddVisit: (visit: AddVisitInfo|undefined) => {    
  return axiosInstance.post<any>(
    `Visit/AddVisit`, visit, {        
      headers: { Authorization: `Bearer ${RescoStorage.getToken()}` }
    }
  );
}
}
export default VisitAPI;
